// Presentation adapter for Duplin Discounts. The app remains the sole owner of
// radio listeners, quantity tiers, selling_plan inputs and purchase pricing.
(() => {
  const currency = document.currentScript?.dataset.currency || 'USD';
  const money = new Intl.NumberFormat(document.documentElement.lang || 'en', {
    style: 'currency', currency,
  });
  const observed = new WeakSet();

  function textNode(parent, className, text, tag = 'span') {
    let node = parent.querySelector(`:scope > .${className}`);
    if (!node) {
      node = document.createElement(tag);
      node.className = className;
      parent.append(node);
    }
    if (text !== undefined && node.textContent !== text) node.textContent = text;
    return node;
  }

  function render(productInfo) {
    productInfo.querySelectorAll('.allure-subscription-block').forEach((block) => {
      const card = block.querySelector('.allure-subscription-block__card');
      const oneTime = block.querySelector('.allure-subscription-block__row--one-time');
      const options = block.querySelector('.allure-subscription-block__options');
      // Leave an incompatible future app version untouched instead of replacing
      // its markup or falling back to guessed product prices.
      if (!card || !oneTime || !options || !block.querySelector('.allure-subscription-block__group-heading')) return;
      let data;
      try {
        data = JSON.parse(block.querySelector('[data-allure-variant-prices]')?.textContent || 'null');
      } catch { return; }
      const variant = productInfo.querySelector('form[action*="/cart/add"] [name="id"]')?.value;
      const prices = data?.prices?.[variant];
      if (prices?.[''] == null) return;

      const labels = [...options.querySelectorAll('.allure-subscription-block__option--plan')]
        .filter((label) => !label.classList.contains('allure-subscription-block__option--hidden'));
      if (!labels.length) return;
      block.classList.add('pdp-purchase-options');
      const heading = textNode(block, 'pdp-purchase-options__heading', 'Purchase Options:', 'p');
      if (heading.nextElementSibling !== card) block.insertBefore(heading, card);
      textNode(oneTime.querySelector('label'), 'pdp-purchase-options__one-time-price', money.format(prices[''] / 100));

      labels.forEach((label) => {
        const row = label.querySelector('.allure-subscription-block__option-row') || label;
        const frequency = label.dataset.frequencyKey;
        textNode(row, 'pdp-purchase-options__label', labels.length === 1 ? 'Subscription' : `Subscription — ${frequency}`);

        const tiers = [...label.querySelectorAll('.allure-subscription-block__slab')]
          .filter((tier) => prices[tier.dataset.planId] != null)
          .map((tier) => `${tier.textContent.trim()} bottles → ${money.format(prices[tier.dataset.planId] / 100)} / bottle`);
        let details = label.nextElementSibling;
        if (!details?.classList.contains('pdp-purchase-options__details')) {
          details = document.createElement('div');
          details.className = 'pdp-purchase-options__details';
          label.after(details);
        }
        details.hidden = !tiers.length;
        if (!tiers.length) return;
        textNode(details, 'pdp-purchase-options__benefit', 'Buy more, save more', 'p');
        textNode(details, 'pdp-purchase-options__description', 'Subscribe and save on every bottle.', 'p');
        const list = textNode(details, 'pdp-purchase-options__tiers', undefined, 'ul');
        if (list.textContent !== tiers.join('')) {
          list.replaceChildren(...tiers.map((text) => {
            const item = document.createElement('li');
            item.textContent = text;
            return item;
          }));
        }
      });
    });
  }

  function initialize() {
    document.querySelectorAll('product-info').forEach((productInfo) => {
      if (observed.has(productInfo)) return;
      observed.add(productInfo);
      let scheduled = false;
      const schedule = () => {
        if (scheduled) return;
        scheduled = true;
        requestAnimationFrame(() => {
          scheduled = false;
          if (productInfo.isConnected) render(productInfo);
          else observer.disconnect();
        });
      };
      // Also covers app price updates and variant-driven section replacement.
      const observer = new MutationObserver(schedule);
      observer.observe(productInfo, { childList: true, subtree: true, characterData: true });
      productInfo.addEventListener('change', schedule);
      render(productInfo);
    });
  }
  initialize();
  document.addEventListener('shopify:section:load', initialize);
})();
